// test2478
(2478 && 0);
